import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    
    
    // Check if it's a wallet extension error
    const errorMsg = error?.message || error?.toString() || '';
    const errorMsgLower = errorMsg.toLowerCase();
    const isWalletError = errorMsgLower.includes('user rejected') || 
                         errorMsgLower.includes('user denied') ||
                         errorMsgLower.includes('user cancelled') ||
                         errorMsgLower.includes('wallet') ||
                         errorMsgLower.includes('extension') ||
                         errorMsgLower.includes('metamask') ||
                         errorMsgLower.includes('phantom') ||
                         errorMsgLower.includes('keplr') ||
                         errorMsgLower.includes('provider') ||
                         errorMsgLower.includes('inpage') ||
                         errorMsgLower.includes('content script');
    
    if (isWalletError) {
      // Suppress wallet errors - don't update state
      console.debug('Suppressed wallet extension error in ErrorBoundary:', error);
      // Prevent the error from propagating to React's error overlay
      if (error && typeof error.preventDefault === 'function') {
        error.preventDefault();
      }
      return null; // Don't trigger error state
    }
    
    // For real errors, update state
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Check if it's a wallet extension error
    const errorMsg = error?.message || error?.toString() || '';
    const isWalletError = errorMsg.toLowerCase().includes('user rejected') || 
                         errorMsg.toLowerCase().includes('wallet') ||
                         errorMsg.toLowerCase().includes('extension') ||
                         errorMsg.toLowerCase().includes('metamask') ||
                         errorMsg.toLowerCase().includes('phantom');
    
    if (isWalletError) {
      // Suppress wallet errors
      console.debug('Suppressed wallet extension error in componentDidCatch:', error);
      return;
    }
    
    // Log real errors
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', color: '#ef4444' }}>
          <h2>Something went wrong</h2>
          <p>{this.state.error?.message || 'An unexpected error occurred'}</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

